import { useAppSelector } from '@verantos-dev/app-state-base';
import {
  selectCohortDefinition,
  selectFullCohortDsl,
  selectHasUnsavedChanged,
} from '@verantos-dev/app-state-cohort-builder';
import { parseCohortDefinitionQuery } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import { useGetAllConceptGroupFromDefinition } from '../../../../../hooks/common/useGetAllConceptGroupFromDefinition';
import { hasValidEventNameMapping } from '../../../../../utils/event-utils';

export const useValidateCohortDefinition = () => {
  const fullCohortDsl = useAppSelector(selectFullCohortDsl);
  const hasUnsavedChanges = useAppSelector(selectHasUnsavedChanged);
  const cohortDefinition = useAppSelector(selectCohortDefinition);

  const { conceptGroups } = useGetAllConceptGroupFromDefinition();
  const { isEventNameMappingValid } = hasValidEventNameMapping(cohortDefinition);

  if (!fullCohortDsl) {
    return {
      isCohortDefinitionValid: false,
    };
  }
  const { customErrorListener } = parseCohortDefinitionQuery(fullCohortDsl);
  customErrorListener.errors.length > 0 &&
    console.info(
      'Cohort definition is invalid due to the following errors:',
      customErrorListener.errors
    );

  const hasNonExistingConcepts = conceptGroups.some((conceptGroup) => !conceptGroup.isExist);

  return {
    hasUnsavedChanges,
    hasNonExistingConcepts,
    isEventNameMappingValid,
    hasDslValue: !!fullCohortDsl,
    isCohortDefinitionValid: customErrorListener.errors.length === 0,
  };
};
